module.exports = __webpack_public_path__ + "img/gsjj.84f11127.png";